// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pyJgG","left":"styles_left__1mGAA"};